import React from "react";
import AllMotorCyles from "../../assets/final-images/Resources/Insurance/All-Motors.png";
import Aetna from "../../assets/final-images/Resources/Insurance/aetna-international-logo.png";
import AvMed from "../../assets/final-images/Resources/Insurance/AvMed.png";
import BlueShield from "../../assets/final-images/Resources/Insurance/Blue-Cross-Blue-Shield-Logo.png";
import Freedom from "../../assets/final-images/Resources/Insurance/FH_logo.gif";
import Humana from "../../assets/final-images/Resources/Insurance/humana.png";
import Medicare from "../../assets/final-images/Resources/Insurance/medicare.svg";
import Optimum from "../../assets/final-images/Resources/Insurance/optimum.png";
import OptimumServe from "../../assets/final-images/Resources/Insurance/optum-serve.svg";
import Tricare from "../../assets/final-images/Resources/Insurance/TRICARElogo.svg";
import Ultimate from "../../assets/final-images/Resources/Insurance/uhp-logo.png";
import United from "../../assets/final-images/Resources/Insurance/united-healthcare-logo.png";
import UnitedCommunity from "../../assets/final-images/Resources/Insurance/Cigna Logo.png";
import bluecross from "../../assets/final-images/Resources/Insurance/bluecross logo.png";
import Veterans from "../../assets/final-images/Resources/Insurance/Veterans.png";
import Workers from "../../assets/final-images/Resources/Insurance/workers.png";

const insuranceOptions = [
  { label: "Aetna", img: Aetna },
  { label: "All Motor Vehicle Claims", img: AllMotorCyles },
  { label: "AvMed", img: AvMed },
  { label: "Blue Cross Blue Shield", img: BlueShield },
  { label: "Federal Blue Cross", img: bluecross },
  { label: "Freedom Health", img: Freedom },
  { label: "Humana", img: Humana },
  { label: "Medicare", img: Medicare },
  { label: "Optimum Healthcare", img: Optimum },
  { label: "Optum Serve", img: OptimumServe },
  { label: "Tricare", img: Tricare },
  { label: "Ultimate", img: Ultimate },
  { label: "United Healthcare", img: United },
  { label: "Cigna", img: UnitedCommunity },
  { label: "Veterans Choice Program", img: Veterans },
  { label: "Workers' Compensation", img: Workers },
];

export default function Insurance() {
  return (
    <div className="  xl:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-5 gap-0">
        {[...insuranceOptions]
          .sort((a, b) =>
            a.label.toLowerCase().localeCompare(b.label.toLowerCase()),
          )
          .map((option, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-between p-8 h-auto"
            >
              {/* Logo */}
              <div className="flex flex-col items-center">
                <div className="w-[243px] h-40 flex justify-center bg-[#FEECE2] rounded-lg p-4 items-center">
                  <img
                    src={option.img}
                    alt={option.label + " Insurance"}
                    className="m-2 object-contain"
                  />
                </div>

                <p className="text-center text-lg font-medium leading-snug mt-4 text-[#ccc] font-robout">
                  {option.label}
                </p>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
